/**
 * 이 파일은 Aui 의 일부입니다. (https://aui.moimz.tools)
 *
 * 로컬 목록 데이터스토어 클래스를 정의한다.
 *
 * @file /src/models/store/list/Local.ts
 * @author Arzz <arzz@arzz.com>
 * @license MIT License
 * @modified 2025. 8. 2.
 */
import * as parent from '@models/store/list/List';
import { Local as Provider } from '@models/store/provider/Local';

export interface Listeners<T> extends parent.Listeners<T> {}

export interface Properties<T, P extends Provider> extends parent.Properties<T, P> {
    /**
     * 이벤트리스너
     */
    listeners?: Listeners<T>;
}

export class Local extends parent.List<Provider> {
    /**
     * 로컬 목록 데이터스토어 클래스를 정의한다.
     *
     * @param properties - 초기속성
     */
    constructor(public properties: Properties<Local, Provider> = null) {
        super(properties);

        this.provider = new Provider(this, properties.provider);
    }
}
